module.exports = __webpack_public_path__ + "assets/img/SISTER1.088e70c1.png";